import { render, staticRenderFns } from "./ProfiletwoComponent.vue?vue&type=template&id=278476fc"
import script from "./ProfiletwoComponent.vue?vue&type=script&lang=js"
export * from "./ProfiletwoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports